import React from 'react';
import Paper from 'material-ui/Paper';
import TitleBig from "./TitleBig";

export default class CustomPaper extends React.Component {

    render() {
        return (
            <div style={{marginTop:15, marginBottom:15, height:'100%', color:'white'}} className="container-fluid">
                <Paper style={{height:'100%'}}  zDepth={4}>
                    <TitleBig title={this.props.title}/>
                    <div style={{ paddingLeft:15, paddingBottom:20, paddingTop:20, paddingRight:15}}>
                        {this.props.children}
                    </div>
                </Paper>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/utils/CustomPaper.js